import React from 'react';

export const privacyPolicyContent = (
  <div className="legal-content">
    <p><strong>Last Updated: June 27, 2026</strong></p>
    <p>Welcome to BuzzMinded ("Company," "we," "our," or "us"). We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how BuzzMinded collects, uses, stores, and protects your information when you visit our website or use our digital marketing and graphic design services.</p>
    <p>By using our website, you agree to the practices described in this Privacy Policy.</p>
    
    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>1. About BuzzMinded</h3>
    <p>BuzzMinded is a digital marketing and graphic design agency based in Anand, Gujarat, India. We provide services including:</p>
    <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>
      <li>Search Engine Optimization (SEO)</li>
      <li>Social Media Marketing</li>
      <li>Google Ads (PPC)</li>
      <li>Meta Ads (Facebook & Instagram)</li>
      <li>Website Design & Development</li>
      <li>Graphic Design</li>
      <li>Branding</li>
      <li>Content Marketing</li>
      <li>Email Marketing</li>
      <li>Logo Design</li>
      <li>Video Editing</li>
      <li>Digital Strategy & Consulting</li>
    </ul>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>2. Information We Collect</h3>
    <p>We may collect the following information:</p>
    <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>
      <li><strong>Personal Information:</strong> Full Name, Email Address, Phone Number, Company Name, Business Website, Business Information, Billing Information (if applicable)</li>
      <li><strong>Technical Information:</strong> IP Address, Browser Type, Device Information, Operating System, Website Usage Data, Cookies, Analytics Data</li>
    </ul>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>3. How We Use Your Information</h3>
    <p>We use your information to:</p>
    <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>
      <li>Respond to inquiries</li>
      <li>Provide digital marketing services</li>
      <li>Manage client projects</li>
      <li>Improve our website</li>
      <li>Send quotations and proposals</li>
      <li>Process payments</li>
      <li>Communicate project updates</li>
      <li>Improve customer experience</li>
      <li>Analyze website traffic</li>
      <li>Prevent fraud and unauthorized access</li>
      <li>Comply with legal obligations</li>
    </ul>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>4. Cookies</h3>
    <p>Our website may use cookies to: Improve website performance, Remember visitor preferences, Analyze website traffic, Measure marketing performance. You can disable cookies through your browser settings.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>5. Third-Party Services</h3>
    <p>We may use trusted third-party tools, including: Google Analytics, Google Ads, Meta Business Tools, Payment Gateways, CRM Software, Email Marketing Platforms, Cloud Hosting Providers. These providers have their own privacy policies governing how they handle your information.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>6. Information Sharing</h3>
    <p>BuzzMinded does not sell, rent, or trade your personal information.</p>
    <p>We may share information only: With trusted service providers, To comply with legal requirements, To protect our legal rights, During business transfers or mergers (if applicable).</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>7. Data Security</h3>
    <p>We implement reasonable administrative, technical, and organizational measures to protect your personal information. However, no internet transmission or electronic storage method can be guaranteed to be completely secure.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>8. Data Retention</h3>
    <p>We retain your information only as long as necessary to: Deliver our services, Meet legal and tax obligations, Resolve disputes, Enforce agreements.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>9. Your Rights</h3>
    <p>Depending on applicable law, you may have the right to: Access your information, Correct inaccurate information, Request deletion of your data, Withdraw consent where applicable, Object to certain processing, Request a copy of your personal information. To exercise these rights, please contact us.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>10. Third-Party Links</h3>
    <p>Our website may contain links to third-party websites. BuzzMinded is not responsible for the privacy practices or content of external websites.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>11. Children's Privacy</h3>
    <p>Our services are intended for individuals aged 18 or older. We do not knowingly collect personal information from children.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>12. Policy Updates</h3>
    <p>We may update this Privacy Policy periodically. Changes will be posted on this page with the updated revision date.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>13. Contact Us</h3>
    <p><strong>BuzzMinded</strong><br/>
    Anand, Gujarat, India<br/>
    Email: hello@buzzminded.in<br/>
    Phone: +91-7227095393<br/>
    Website: https://buzzminded.in</p>
  </div>
);

export const termsContent = (
  <div className="legal-content">
    <p><strong>Last Updated: June 27, 2026</strong></p>
    <p>Welcome to BuzzMinded. By accessing our website or using our services, you agree to these Terms of Service.</p>
    
    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>1. Services</h3>
    <p>BuzzMinded provides digital marketing and creative services including:</p>
    <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>
      <li>SEO</li>
      <li>Website Design & Development</li>
      <li>Graphic Design</li>
      <li>Branding</li>
      <li>Google Ads</li>
      <li>Social Media Marketing</li>
      <li>Meta Ads</li>
      <li>Content Creation</li>
      <li>Email Marketing</li>
      <li>Digital Consulting</li>
    </ul>
    <p>The scope of work for each project will be defined in a proposal, quotation, or service agreement.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>2. Client Responsibilities</h3>
    <p>Clients agree to:</p>
    <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>
      <li>Provide accurate information.</li>
      <li>Supply required content, images, logos, and approvals on time.</li>
      <li>Respond promptly to requests for feedback.</li>
      <li>Ensure they have the rights to any materials they provide.</li>
    </ul>
    <p>Delays in providing required information may affect project timelines.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>3. Payments</h3>
    <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>
      <li>Payments must be made according to the agreed quotation or invoice.</li>
      <li>Projects may require an advance payment before work begins.</li>
      <li>Final deliverables may be released after full payment is received.</li>
      <li>Late payments may result in project delays or suspension of services.</li>
    </ul>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>4. Revisions</h3>
    <p>Most projects include a limited number of revisions as outlined in the project proposal. Additional revisions or changes beyond the agreed scope may incur extra charges.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>5. Intellectual Property</h3>
    <p>Upon full payment, ownership of approved final deliverables transfers to the client, unless otherwise agreed in writing.</p>
    <p>BuzzMinded retains ownership of:</p>
    <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>
      <li>Drafts</li>
      <li>Concepts</li>
      <li>Working files</li>
      <li>Internal tools</li>
      <li>Proprietary processes</li>
      <li>Portfolio rights (unless restricted by agreement)</li>
    </ul>
    <p>Any third-party fonts, stock images, plugins, or licensed assets remain subject to their respective license terms.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>6. Marketing Results</h3>
    <p>While BuzzMinded uses industry best practices, we cannot guarantee: #1 Google rankings, Specific traffic increases, Sales targets, Lead volumes, Advertising performance.</p>
    <p>Results depend on factors including competition, market conditions, budgets, and search engine or platform algorithm changes.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>7. Confidentiality</h3>
    <p>We will treat client information as confidential and use it only for providing agreed services, except where disclosure is required by law or authorized by the client.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>8. Acceptable Use</h3>
    <p>Clients agree not to use our services for: Illegal activities, Fraudulent practices, Spam, Copyright infringement, Distribution of malware, Hate speech or unlawful content, Any activity that violates applicable laws.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>9. Project Cancellation</h3>
    <p>Either party may terminate a project by providing written notice. Upon cancellation: The client must pay for work completed up to the cancellation date. Advance payments are generally non-refundable unless otherwise stated in the agreement. Any completed deliverables paid for will be provided to the client.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>10. Limitation of Liability</h3>
    <p>To the maximum extent permitted by law, BuzzMinded shall not be liable for indirect, incidental, consequential, or special damages arising from the use of our services. Our total liability is limited to the amount paid by the client for the specific service giving rise to the claim.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>11. Third-Party Platforms</h3>
    <p>Our services may involve third-party platforms such as Google, Meta, WordPress, Shopify, or other software providers. We are not responsible for changes, outages, policy updates, or actions taken by these third parties.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>12. Website Availability</h3>
    <p>We strive to keep our website available but do not guarantee uninterrupted or error-free access.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>13. Governing Law</h3>
    <p>These Terms of Service are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts located in Anand, Gujarat.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>14. Changes to These Terms</h3>
    <p>BuzzMinded may update these Terms of Service at any time. Continued use of our website or services after updates constitutes acceptance of the revised Terms.</p>

    <h3 style={{ color: '#fff', marginTop: '24px', marginBottom: '12px' }}>15. Contact Information</h3>
    <p><strong>BuzzMinded</strong><br/>
    Anand, Gujarat, India<br/>
    Email: hello@buzzminded.in<br/>
    Website: https://buzzminded.in</p>
  </div>
);
